import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    let active = true;

    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      setLoading(false);

      authAPI.getMe()
        .then((response) => {
          if (!active) return;
          localStorage.setItem('user', JSON.stringify(response.data));
          setUser(response.data);
        })
        .catch(() => {
          // Keep the previous behavior for temporary connection failures. A
          // 401 is handled centrally by the API interceptor.
        });
    } else {
      setLoading(false);
    }

    return () => {
      active = false;
    };
  }, []);

  const login = async (email, password) => {
    const response = await authAPI.login({ email, password });
    const { access_token, user: userData } = response.data;
    
    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    
    return userData;
  };

  const register = async (name, email, password, registration_key) => {
    const response = await authAPI.register({ name, email, password, registration_key });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
